import styled from "styled-components";

import { Check } from "@similarweb/icons";
import { colorsPalettes, setElevation } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

export const CheckmarkIcon = styled(Check)`
    width: 20px;
    height: 20px;
    flex-shrink: 0;

    svg {
        height: 8.5px;
        width: 11px;
    }
`;

export const Container = styled(Flex)`
    width: 100%;
    align-items: stretch;
    justify-content: center;
    gap: 16px;
`;

export const Card = styled.div<{ isRecommended: boolean }>`
    box-sizing: border-box;
    background: ${colorsPalettes.carbon["0"]};
    border-radius: ${({ isRecommended }) => (isRecommended ? "0 0 12px 12px" : "12px")};
    border: 1px solid ${({ isRecommended }) => (isRecommended ? colorsPalettes.blue[400] : "transparent")};
    ${setElevation("Z2")}
    padding: 24px 12px;
    flex: 1;
    min-width: 0;
    position: relative;
`;

export const TagContainer = styled(Flex)`
    position: absolute;
    /* left/right (instead of width: 100%) so the badge's own edges land exactly on the card's
       outer border edge - width: 100% would size against the card's padding box and leave the
       card's 1px border peeking out past the badge on both sides. */
    top: -20px;
    left: -1px;
    right: -1px;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    background-color: ${colorsPalettes.blue[400]};
    border: 1px solid ${colorsPalettes.blue[400]};
    border-bottom: none;
    border-radius: 16px 16px 0 0;
    height: 20px;
`;

export const Tag = styled(Text)``;

export const Title = styled(Text)`
    display: block;
    max-width: 133px;
    min-height: 32px;
    margin-bottom: 16px;
`;

export const TrialText = styled(Text)`
    display: block;
`;

export const PriceCaption = styled(Text)`
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    margin-bottom: 16px;
`;

export const ChoosePlanButton = styled(Button)`
    margin: 16px 0 24px;
`;

export const FeatureList = styled(Stack)`
    gap: 8px;
`;

export const Feature = styled(Flex)`
    align-items: center;
    gap: 4px;
`;

export const FeatureText = styled(Text)``;
